import React from "react";
import styled from "styled-components";

import { ButterflyEditor } from "butterfly-editor";

const DemoContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 2em;
`;

const DemoPage = () => {
  return (
    <DemoContainer>
      <h3>Full Butterfly Editor DEMO</h3>
      <>
        <ButterflyEditor
          config={{
            allowEditorFullExpand: true,
            allowHTMLExport: true,
            allowResize: true,
            initialHeight: "400px"
          }}
        />
      </>
    </DemoContainer>
  );
};

export default DemoPage;
